import React from "react";

import GuideContinent from "./component/GuideContinent";
import GuideCountry from "./component/GuideCountry";
import GuideState from "./component/GuideState";
import GuideCity from "./component/GuideCity";
import GuideType from "./component/GuideType";

const GuideCasino = (props) => {
  const { slugs, paramsFinal } = props;
  if (slugs.length === 1) {
    return <GuideContinent {...props} continentSelected={slugs[0]} />;
  } else if (slugs.length === 2) {
    if (
      !slugs[1].includes("-city") &&
      !slugs[1].includes("-state") &&
      slugs[0] == "world"
    ) {
      return (
        <GuideType
          {...props}
          continentSelected={slugs[0]}
          typeSelected={slugs[1]}
        />
      );
    } else {
      return (
        <GuideCountry
          {...props}
          continentSelected={slugs[0]}
          countrySelected={slugs[1]}
        />
      );
    }
  } else if (slugs.length === 3) {
    if (!slugs[2].includes("-city") && !slugs[2].includes("-state")) {
      return (
        <GuideType
          {...props}
          continentSelected={slugs[0]}
          countrySelected={slugs[1]}
          typeSelected={slugs[2]}
        />
      );
    } else if (slugs[2].includes("-state")) {
      return (
        <GuideState
          {...props}
          continentSelected={slugs[0]}
          countrySelected={slugs[1]}
          stateSelected={slugs[2]}
        />
      );
    } else {
      return (
        <GuideCity
          {...props}
          continentSelected={slugs[0]}
          countrySelected={slugs[1]}
          citySelected={slugs[2]}
        />
      );
    }
  } else if (slugs.length === 4) {
    return (
      <GuideType
        {...props}
        continentSelected={slugs[0]}
        countrySelected={slugs[1]}
        stateSelected={slugs[2]?.includes("-state") ? slugs[2] : null}
        citySelected={!slugs[2]?.includes("-state") ? slugs[2] : null}
        typeSelected={slugs[3]}
      />
    );
  }
};

export default GuideCasino;
